<template>
  <div class="flex flex-col">
    <span class="text-sm border-b text-gray-400">Pending Notifications</span>
    <div class="p-2 rounded-md bg-gray-100 shadow-sm">
      <div class="relative p-2 rounded-md bg-gray-50">
        <div class="absolute right-2 flex-row">
          <button class="px-1 rounded-sm text-sm font-italic text-gray-400 bg-gray-200 hover:bg-gray-300"
            @click="loadPendingNotifications">
            Refresh
          </button>
        </div>
        <div class="p-2 flex flex-col gap-2">
          <div class="flex flex-row">
            <MultiCheckboxField
              alignment="col"
              :options="checkboxOptions"
              v-model="formValues.selectedCheckboxOptions"
            >
            Filters
          </MultiCheckboxField>
          </div>
          <div class="grid grid-cols-3 gap-2">
            <TextField
              v-if="showFilterStudents"
              v-model="formValues.filterStudents">
              Student Field Filter
            </TextField>
            <VSelectionField class="col-span-2"
              v-if="showFilterPartitions"
              :multiple="true"
              v-model="formValues.selectedPartitions"
              :options="partitionOptions">
              Partitions
            </VSelectionField>
          </div>
          <div class="grid grid-cols-3 gap-2">
            <TextField
              v-if="showFilterDistricts"
              v-model="formValues.filterDistricts">
              District Field Filter
            </TextField>
            <TextField
              v-if="showFilterBuildings"
              v-model="formValues.filterBuildings">
              Building Field Filter
            </TextField>
          </div>
          <div class="grid grid-cols-4 gap-2">
            <div class="flex flex-col gap-1">
              <Button class="bg-gray-200 hover:bg-gray-50"
                :class="{
                  'bg-sky-600 hover:bg-sky-400 text-white': selectAllToggle,
                }"
                @click="onSelectAll">
                Select All
              </Button>
              <Button class="bg-gray-200 hover:bg-gray-50"
                @click="onDeselectAll">
                Deselect All
              </Button>
            </div>
            <div class="col-span-2">
              Number Selected: {{ this.selectedPendingNotifications.length }}
            </div>
            <Button class="flex flex-row items-center justify-center bg-red-600 hover:bg-red-400 text-white"
              ref="deleteAllButton"
              @click="onDeleteSelected">
              Delete Selected
              <Spinner
                v-if="displayDeleteSpinner"
                :size="8"
              />
            </Button>
          </div>
          <Button class="mt-2"
            v-if="confirmDeletion"
            color="blue"
            v-outside-click="{
              exclude: ['deleteAllButton'],
              handler: 'cancelDeletion'
            }"
            :disabled="!confirmDeletionButtonEnabled"
            @click="onDeletionConfirmed">
            Confirm Deletion
          </Button>
        </div>
        <div class="flex relative justify-center items-center mt-4">
          <PaginationButton
            ref="tableTop"
            :pages="pages"
            :initPage="currentPage"
            @toPage="onToPage"
          />
          <div class="absolute right-0 text-gray-400 mt-1 text-sm">
            Total Entries: {{ totalPendingNotifications }}
          </div>
        </div>
        <Spinner
          v-if="displayLoadingPendingNotificationsSpinner"
          message="Loading Pending Notifications"
          :size="16"
        />
        <DataTable
          ref="pendingNotificationsTable"
          :tableHeads="pendingNotificationsTableHeads"
          :dataKeyList="pendingNotificationsTableKeys"
          :dataItems="pendingNotifications"
          uniqueKeyValue="id"
          @toggle="onTogglePendingNotification"
          @toggleOpen="onToggleOpenTable"
        />
        <div class="flex flex-col justify-center pb-4" v-if="openTable && pendingNotifications.length > 0">
          <Button class="text-gray-300 text-sm w-full hover:bg-gray-100"
            @click="scrollToTableTop">
            Scroll To Top
          </Button>
          <div class="flex flex-row justify-center">
            <PaginationButton
              :pages="pages"
              :initPage="currentPage"
              @toPage="onToPage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from './DataTable.vue'

import PaginationButton from '../PaginationButton.vue'
import Spinner from '../Spinner.vue'

import TextField from '../formComponents/TextField.vue'
import VSelectionField from '../formComponents/VSelectionField.vue'

import MultiCheckboxField from '../formComponents/MultiCheckboxField.vue'

import Button from '../Button.vue'

import user from '../../services/user/user.js'
import partitions from '../../services/partitions.js'

import pendingNotificationService from '../../services/routingManagement/pendingNotifications.js'

export default {
  components: {
    DataTable,
    PaginationButton,
    Spinner,
    TextField,
    VSelectionField,
    MultiCheckboxField,
    Button,
  },
  data() {
    return {
      formValues: {
        selectedCheckboxOptions: [],
        filterStudents: undefined,
        selectedPartitions: [],
        filterDistricts: undefined,
        filterBuildings: undefined,
      },

      openTable: false,
      displayLoadingPendingNotificationsSpinner: false,

      pendingNotificationsTableHeads: [
        // 'ID',
        'Internal ID',
        'First Name',
        'Last Name',
        'Schedule Request',
        'Buliding',
      ],
      pendingNotificationsTableKeys: [
        // 'id',
        'internalId',
        'firstName',
        'lastName',
        'scheduleRequest',
        'building',
      ],

      pages: undefined,
      totalPendingNotifications: 0,
      currentPage: 1,
      pendingNotifications: [],

      selectedPendingNotifications: [],
      selectAllToggle: false,

      checkboxOptions: [
        'Students',
        'Partitions',
        'Districts',
        'Buildings',
      ],

      partitions: [],
      partitionOptions: undefined,

      confirmDeletion: false,
      confirmDeletionButtonEnabled: false,
      enableDeletionButtonDelay: undefined,

      formValuesChangeApiCallDelay: undefined,
      displayDeleteSpinner: false,
    }
  },
  methods: {
    callOnceWithDelay(callback, delayTime) {
      if (this.formValuesChangeApiCallDelay) {
        clearTimeout(this.formValuesChangeApiCallDelay)
      }
      this.formValuesChangeApiCallDelay = setTimeout(() => {
        callback()
      }, delayTime)
    },
    async loadPendingNotifications() {
      this.selectAllToggle = false
      let queryParams = this.createQueryParams()
      console.log(queryParams)
      let serverData = await pendingNotificationService.getData(queryParams)
      this.pages = serverData.pages
      this.totalPendingNotifications = serverData.page_data.num_pending_notifications
      this.pendingNotifications = serverData.content.map(pendingNotificationService.remapData)
    },
    createQueryParams() {
      let queryParams = {
        page: this.currentPage,
      }
      if (this.showFilterStudents) {
        queryParams.studentFilter = this.formValues.filterStudents
      }
      if (this.showFilterPartitions) {
        queryParams.partitionFilter = this.formValues.selectedPartitions
      }
      if (this.showFilterDistricts) {
        queryParams.districtFilter = this.formValues.selectedDistricts
      }
      if (this.showFilterBuildings) {
        queryParams.buildingFilter = this.formValues.selectedBuildings
      }
      return queryParams
    },
    onToPage(pageNumber) {
      this.currentPage = pageNumber
      this.loadPendingNotifications()
    },
    onTogglePendingNotification(item, isAdd) {
      if (isAdd) {
        this.selectedPendingNotifications.push(item.id)
      }
      else {
        let index = this.selectedPendingNotifications.indexOf(item.id)
        if (index >= 0) {
          this.selectAllToggle = false
          this.selectedPendingNotifications.splice(index, 1)
        }
      }
    },
    onToggleOpenTable() {
      this.openTable = !this.openTable
    },
    scrollToTableTop() {
      let ref = this.$refs.tableTop
      ref.$el.scrollIntoView({
        behavior: 'smooth',
      })
    },
    onSelectAll() {
      this.selectAllToggle = true
      this.selectedPendingNotifications = this.selectedPendingNotifications.concat(this.pendingNotifications.map(item => item.id))
      this.selectedPendingNotifications = [...new Set(this.selectedPendingNotifications)]
      this.$refs.pendingNotificationsTable.selectAllEntries()
    },
    onDeselectAll() {
      this.selectAllToggle = false
      this.$set(this, 'selectedPendingNotifications', [])
      this.$refs.pendingNotificationsTable.clearSelectedEntries()
    },
    onDeleteSelected() {
      this.confirmDeletion = true
      this.enableDeletionButtonDelay = setTimeout(() => {
        this.confirmDeletionButtonEnabled = true
      }, 2000)
    },
    cancelDeletion() {
      this.confirmDeletion = false
      this.confirmDeletionButtonEnabled = false
      clearTimeout(this.enableDeletionButtonDelay)
    },
    async onDeletionConfirmed() {
      try {
        this.displayDeleteSpinner = true
        await pendingNotificationService.deleteByIds(this.selectedPendingNotifications)
        this.displayDeleteSpinner = false
        this.confirmDeletion = false
        this.confirmDeletionButtonEnabled = false
        this.selectedPendingNotifications = []
        this.loadPendingNotifications()
      }
      catch (error) {
        // do nothing
      }
    },
  },
  async mounted() {
    await user.ready()
    let response = await partitions.getPartitionFromServer()
    this.callOnceWithDelay(() => this.loadPendingNotifications(), 1000)
    this.partitionOptions = response.data.map((partitionData) => {
      return {
        label: partitionData.description,
        value: partitionData.id,
      }
    })
  },
  computed: {
    showFilterStudents() {
      return this.formValues.selectedCheckboxOptions.includes('Students')
    },
    showFilterPartitions() {
      return this.formValues.selectedCheckboxOptions.includes('Partitions')
    },
    showFilterDistricts() {
      return this.formValues.selectedCheckboxOptions.includes('Districts')
    },
    showFilterBuildings() {
      return this.formValues.selectedCheckboxOptions.includes('Buildings')
    },
  },
  watch: {
    formValues: {
      deep: true,
      handler() {
        this.callOnceWithDelay(() => this.loadPendingNotifications(), 1000)
      },
    }
  },
}
</script>
